import { useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CTAWpp = () => {
  const [text, setText] = useState("Fale com nossos especialistas");

  return (
    <button id="ctaWpp">
      <a
        href="https://wa.me/5511990200707?text=Olá%20gostaria%20de%20conhecer%20os%20serviços%20de%20marketing%20digital"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>

        <p>{text}</p>
      </a>
    </button>
  );
};

export default CTAWpp;
